import { useContext } from 'react'

import CookieBannerContext from 'contexts/CookieBannerContext'

const useCookieBanner = () => {
  const context = useContext(CookieBannerContext)

  if (context === undefined) {
    throw new Error(
      'useCookieBanner must be used within a CookieBannerContext.Provider',
    )
  }

  return {
    // Estados
    activeStep: context.activeStep,
    ageGate: context.ageGate,
    appearanceValues: context.appearanceValues,
    banner: context.banner,
    loading: context.loading,
    isAgeGateCompiling: context.isAgeGateCompiling,
    isCompiling: context.isCompiling,
    isScanning: context.isScanning,
    isSubmitting: context.isSubmitting,
    cookies: context.cookies,
    ageGateTextsOverrides: context.ageGateTextsOverrides,
    bannerTextsOverrides: context.bannerTextsOverrides,
    selectedLanguage: context.selectedLanguage,

    // Setters
    setActiveStep: context.setActiveStep,
    setAgeGateTextsOverrides: context.setAgeGateTextsOverrides,
    setAppearanceValues: context.setAppearanceValues,
    setIsAgeGateCompiling: context.setIsAgeGateCompiling,
    setIsCompiling: context.setIsCompiling,
    setIsScanning: context.setIsScanning,
    setIsSubmitting: context.setIsSubmitting,
    setSelectedLanguage: context.setSelectedLanguage,

    // Funções de navegação
    nextStep: context.nextStep,
    backStep: context.backStep,
    goToStep: context.goToStep,

    // Funções de dados
    refreshAgeGate: context.refreshAgeGate,
    refreshBanner: context.refreshBanner,
    updateBannerTextOverride: context.updateBannerTextOverride,
    getBannerTextOverride: context.getBannerTextOverride,
    updateAgeGateTextOverride: context.updateAgeGateTextOverride,
    getAgeGateTextOverride: context.getAgeGateTextOverride,

    // Funções de submit
    setStepSubmit: context.setStepSubmit,
    executeStepSubmit: context.executeStepSubmit,
  }
}

export default useCookieBanner
